"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var React = require("react");

var ReactDOMServer = require("react-dom/server");

var core_1 = require("../../../core");

var renderer_1 = require("../../renderer");

var ChartDisplayView =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ChartDisplayView, _React$Component);

  function ChartDisplayView() {
    _classCallCheck(this, ChartDisplayView);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChartDisplayView).apply(this, arguments));
  }

  _createClass(ChartDisplayView, [{
    key: "render",
    value: function render() {
      var chartState = this.props.manager.chartState;
      var width = chartState.attributes.width;
      var height = chartState.attributes.height;
      var renderer = new core_1.Graphics.ChartRenderer(this.props.manager);
      var graphics = renderer.render();
      return React.createElement("svg", {
        x: 0,
        y: 0,
        width: width,
        height: height,
        viewBox: "0 0 ".concat(width.toFixed(6), " ").concat(height.toFixed(6)),
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        xmlSpace: "preserve"
      }, React.createElement("g", {
        transform: "translate(".concat((width / 2).toFixed(6), ",").concat((height / 2).toFixed(6), ")")
      }, React.createElement(renderer_1.GraphicalElementDisplay, {
        element: graphics
      })));
    }
  }]);

  return ChartDisplayView;
}(React.Component);

exports.ChartDisplayView = ChartDisplayView;

function renderChartToString(dataset, chart, chartState) {
  var manager = new core_1.Prototypes.ChartStateManager(chart, dataset, chartState);
  return ReactDOMServer.renderToString(React.createElement(ChartDisplayView, {
    manager: manager
  }));
}

exports.renderChartToString = renderChartToString;

function renderChartToLocalString(dataset, chart, chartState) {
  var manager = new core_1.Prototypes.ChartStateManager(chart, dataset, chartState);
  var width = chartState.attributes.width;
  var height = chartState.attributes.height;
  var renderer = new core_1.Graphics.ChartRenderer(manager);
  var graphics = renderer.render();
  var urls = new Map();
  var allTasks = [];
  renderer_1.renderGraphicalElementSVG(graphics, {
    chartComponentSync: true,
    externalResourceResolver: function externalResourceResolver(url) {
      var task = new Promise(function (resolve, reject) {
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };

        img.onerror = function () {
          reject(new Error("failed to retrieve map image at url ".concat(url)));
        };

        img.src = url;
      }).then(function (dataurl) {
        urls.set(url, dataurl);
      });
      allTasks.push(task);
      return url;
    }
  });
  core_1.resetMarkID();
  return Promise.all(allTasks).then(function () {
    return ReactDOMServer.renderToString(React.createElement("svg", {
      id: "visChart",
      x: 0,
      y: 0,
      width: width,
      height: height,
      viewBox: "0 0 ".concat(width.toFixed(6), " ").concat(height.toFixed(6)),
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      xmlSpace: "preserve"
    }, React.createElement("g", {
      id: "chartContent",
      transform: "translate(".concat((width / 2).toFixed(6), ",").concat((height / 2).toFixed(6), ")")
    }, renderer_1.renderGraphicalElementSVG(graphics, {
      chartComponentSync: true,
      externalResourceResolver: function externalResourceResolver(url) {
        return urls.get(url);
      }
    }))));
  });
}

exports.renderChartToLocalString = renderChartToLocalString;